import { useCallback, useRef, useState } from 'react';

const useHeldState = <T>(initialState: T) => {
  const [returnedState, setReturnedState] = useState(initialState);

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const timeoutCallback = useRef(() => undefined);

  const holdUntilAfterMs = useCallback((ms: number) => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      timeoutCallback.current();
      timeoutCallback.current = () => undefined;
      timeoutRef.current = undefined;
    }, ms);
  }, []);

  const setHoldableState = useCallback((nextValue: T) => {
    const isHeld = timeoutRef.current !== undefined;
    if (isHeld) {
      timeoutCallback.current = () => {
        setReturnedState(nextValue);
      };
    } else {
      setReturnedState(nextValue);
    }
  }, []);

  return [returnedState, setHoldableState, holdUntilAfterMs] as const;
};

export default useHeldState;
